<template>
  <div class="verification-history-theme">
    <div class="d-flex align-items-center justify-content-between mb-4 verification-case-shell__header p-2">
      <div class="text-uppercase fw-semibold small verification-case-shell__eyebrow">Verification checks ({{ normalized_checks.length }})</div>
    </div>

    <div class="d-grid gap-3">
      <p v-if="normalized_checks.length === 0" class="text-muted mb-0">
        {{ emptyMessage }}
      </p>

      <article
        v-for="item in normalized_checks"
        :key="item.id"
        :class="[
          'border-0 rounded-4 verification-check-card',
          `verification-check-card--${resolvedStatusTone(item)}`
        ]"
      >
        <div class="verification-check-card__header">
          <button
            type="button"
            class="btn btn-link text-decoration-none text-start p-0 d-flex align-items-start gap-3 flex-grow-1 verification-check-card__toggle"
            @click="$emit('toggle-check', item)"
          >
            <span class="rounded-4 d-inline-flex align-items-center justify-content-center flex-shrink-0 verification-check-card__icon-shell">
              <span
                :class="[
                  'rounded-circle d-inline-flex align-items-center justify-content-center onboarding-icon-square-175 verification-check-card__icon',
                  evidenceIconClass(resolvedStatusTone(item))
                ]"
              >
                <i :class="['bi', resolvedStatusTone(item) === 'success' ? 'bi-check-circle' : resolvedStatusTone(item) === 'danger' ? 'bi-x-circle' : resolvedStatusTone(item) === 'warning' ? 'bi-exclamation-circle' : 'bi-dash-circle']"></i>
              </span>
            </span>
            <span class="min-w-0 flex-grow-1 verification-check-card__body">
              <span class="d-block fw-bold text-black mb-1 verification-check-card__title">{{ item.check }}</span>
              <span class="d-block small verification-check-card__meta">{{ item.source }} &middot; Last run: {{ item.last_run }}</span>
              <span v-if="getCheckPassedChips(item).length" class="verification-check-card__passed-chips">
                <span
                  v-for="chip in getCheckPassedChips(item)"
                  :key="chip.key"
                  :class="['verification-check-card__result-chip', chip.match ? 'is-success' : 'is-danger']"
                >
                  <i :class="['bi', chip.match ? 'bi-check-lg' : 'bi-x-lg']" aria-hidden="true"></i>
                  {{ chip.label }}
                </span>
              </span>
            </span>
          </button>
          <div class="d-flex flex-column align-items-end gap-3 flex-shrink-0 verification-check-card__actions">
            <span :class="['badge rounded-pill fw-normal verification-check-card__status', statusBadgeClass(resolvedStatusTone(item))]">
              {{ item.status }}
            </span>
            <span class="verification-check-card__last-run">Last run: {{ item.last_run }}</span>
          </div>
        </div>

        <div class="verification-check-card__action-row">
          <button
            type="button"
            class="verification-check-card__action verification-check-card__action--secondary"
            @click="$emit('toggle-check', item)"
          >
            {{ isExpanded(item) ? 'Close' : 'Open' }}
          </button>
        </div>

        <div v-if="isExpanded(item)" class="verification-check-card__expanded">
          <div v-if="getCheckResultDetailRows(item).length" class="verification-check-card__result-details">
            <div class="text-uppercase fw-semibold small mb-2 verification-check-card__section-label">Result details</div>
            <div class="table-responsive verification-result-detail-table-wrap">
              <table class="table align-middle mb-0 verification-result-detail-table">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Submitted value</th>
                    <th>Provider value</th>
                    <th>Match status</th>
                    <th>Message</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="field in getCheckResultDetailRows(item)"
                    :key="field.key"
                    :class="fieldResultRowClass(field.match)"
                  >
                    <td class="fw-semibold text-black">{{ field.label }}</td>
                    <td>{{ field.user_answer }}</td>
                    <td>{{ field.api_value }}</td>
                    <td>
                      <span :class="['badge rounded-pill fw-normal verification-result-detail-table__badge', statusBadgeClass(field.match ? 'success' : 'danger')]">
                        <i :class="field.match ? 'bi bi-check-circle' : 'bi bi-x-circle'" aria-hidden="true"></i>
                        {{ field.match ? 'Match' : 'Mismatch' }}
                      </span>
                    </td>
                    <td>{{ field.message }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="getCheckHistory(item).length" class="mt-3">
            <div class="text-uppercase fw-semibold small mb-2 verification-check-card__section-label">History</div>
            <div class="d-grid gap-2">
              <div
                v-for="entry in getCheckHistory(item)"
                :key="entry.id"
                class="border rounded-3 px-3 py-2 bg-light-subtle verification-check-card__history-card"
              >
                <div class="d-flex align-items-center justify-content-between gap-3">
                  <span :class="['badge rounded-pill fw-normal', statusBadgeClass(entry.status_tone)]">
                    {{ entry.status }}
                  </span>
                  <span class="small text-muted">{{ entry.last_run }}</span>
                </div>
                <div class="small text-muted mt-2">{{ entry.detail }}</div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script src="./historical_verification_checks_view.js"></script>
